<div class="content-body" id="contentZone" [class.drag-over]="isDraggingOver()" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
  <audio #player (timeupdate)="onTimeUpdate()" (ended)="onAudioEnded()" (loadedmetadata)="onLoadedMetadata()">
    {{ 'content.noBrowserSupport' | translate }}
  </audio>

  <div>
    <div
      class="drop-list"
      cdkDropList
      cdkDropListAutoScroll
      [cdkDropListAutoScrollStep]="15"
      [cdkDropListData]="content()"
      [cdkDropListDisabled]="isReader()"
      (cdkDropListDropped)="drop($event)"
      (cdkDragStarted)="onChunkDragStart()"
      (cdkDragEnded)="onChunkDragEnd()"
    >
      <article class="content-container" [class.from_pop_content]="from() === 'pop-content'">
        @if (content().length === 0 && isDraggingOver() && !isReader()) {
          <div class="insert-placeholder visible empty-list-placeholder">{{ 'Content.DropHere' | translate }}</div>
        } @else {


          <!-- Placeholder for dropping at the very top -->
          <div class="insert-placeholder" [class.visible]="(isDraggingOver() || isChunkDragging()) && insertBelowId() === 'first'"></div>
          <!-- Persistent placeholder for UPLOADING at the top -->
          @if (uploadState(); as state) {
            @if (state.insertId === null) {
              <ng-container *ngTemplateOutlet="uploadProgressPlaceholder"></ng-container>
            }
          }

          @for (piece of content(); track trackById($index, piece)) {
            <div class="chunk-item-wrapper">
              <div class="chunk-wrapper" [id]="piece._id" cdkDrag (cdkDragMoved)="onChunkDragMoved($event)" [cdkDragDisabled]="isReader() || stateService.isMultiSelectMode() || isChunkProcessing(piece)">
                <div *cdkDragPlaceholder class="drag-placeholder"></div>
                <app-chunk
                  (click)="$event.stopPropagation()"
                  [id]="piece._id"
                  [content]="piece"
                  [chunk]="piece"
                  [style]="piece.style"
                  [mode]="'read'"
                  (videoEnded)="stateService.handleAudioEnded()"
                  (shouldReload)="stateService.chunkDeleted()"
                  [mustLoadAudio]="piece.loadAudio"
                  [contentLanguage]="contentLanguage()"
                  [index]="$index"
                  [editingChunk]="editingChunk()"
                  [videoWidth]="videoWidth()"
                  [contentID]="contentID()"
                  (editMe)="toggleEditChunk($event)"
                  (chunkdeleted)="stateService.chunkDeleted()"
                  [courseID]="courseID()"
                  [blogID]="blogID()"
                  [chunkAboveId]="content()[$index - 1]?._id"
                  [chunkBelowId]="content()[$index + 1]?._id"
                  [readOnly]="isReader()"
                />
              </div>
              @if (['file', 'video', 'audio', 'image', 'code', 'quiz', 'latex', 'canvas-transcript', 'whiteboard', 'table'].includes(piece.type) && !isReader()) {
                <div class="add-chunk-button-container">
                  <button mat-icon-button class="add-chunk-button" (click)="insertAt(piece._id)">
                    <mat-icon>add</mat-icon>
                  </button>
                </div>
              }
              @if (activeInsertPlaceholder() === piece._id && !isReader()) {
                <div class="create-chunk-container">
                  <app-create-chunk
                    [mode]="'create-chunk'"
                    [courseID]="courseID()"
                    [noteID]="noteID()"
                    [blogID]="blogID()"
                    [lecture]="lecture()"
                    [section]="section()"
                    [chunkAboveId]="content()[$index - 1]?._id"
                    [chunkBelowId]="content()[$index + 1]?._id"
                    [contentID]="contentID()"
                    [contentName]="contentName()"
                    [contentType]="contentType()"
                  />
                </div>
              }
            </div>
            <!-- Placeholder for DRAGGING -->
            <div class="insert-placeholder" [class.visible]="(isDraggingOver() || isChunkDragging()) && insertBelowId() === piece._id"></div>
            <!-- Persistent placeholder for UPLOADING -->
            @if (uploadState(); as state) {
              @if (state.insertId === piece._id) {
                <ng-container *ngTemplateOutlet="uploadProgressPlaceholder"></ng-container>
              }
            }
          }
        }

        @if (!loading()) {
          @if (content().length === 0) {
            <div class="no-content-yet">
              <div class="text-center">
                <p>{{ 'Content.NoContent' | translate }}</p>
              </div>
            </div>
          }
        }

        <!-- @if (activeInsertPlaceholder() === null) {
        <div appearance="outlined">
          <app-create-chunk
            [mode]="'create-chunk'"
            [courseID]="courseID()"
            [noteID]="noteID()"
            [blogID]="blogID()"
            [lecture]="lecture()"
            [section]="section()"
            [chunkAboveId]="content().length ? content()[content().length - 1]?._id : null"
            [chunkBelowId]="content().length ? content()[content().length - 1]?._id : null"
            [contentID]="contentID()"
            [contentName]="contentName()"
            [contentType]="contentType()"
            />
        </div>
        } -->
      </article>
    </div>
  </div>
</div>

<ng-template #uploadProgressPlaceholder>
  <div class="upload-progress-placeholder">
    @if (uploadState().status === 'uploading') {
      <span>{{ uploadState().progress }}%</span>
    } @else if (uploadState().status === 'creating') {
      <mat-progress-spinner [diameter]="24" mode="indeterminate"></mat-progress-spinner>
    }
  </div>
</ng-template>

<app-bulk-action-bar></app-bulk-action-bar>
